import { APICore } from '../../helpers/api/apiCore';
const api = new APICore();
function tagSearch(params) {
    const { search = '', limit = 100, pages = 0 } = params?.data || {};
    return api.get(`/inbound/findTagSearch?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}
export { tagSearch };
